import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import './App.css';
//components
import Home from './components/Home/Home'
import Choosepage from './components/Choosepage/Choosepage'

function App() {
  

  return (

    <Router>
          <div className="App">
  
      <Switch>
        <Route path="/home">
          <Home />
        </Route>
        <Route path="/choosepage">
          <Choosepage />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
    
    </div>
  </Router>

      
   
  );
}

export default App;
